import * as ents from '@attain-apps/entities'
import type { PartialId } from '@attain-apps/string-builder'
import { TypeChecker } from '@attain-apps/type-guards'

const IS_RESPONSIBLE_MODEL =
  ents.extra.quiver.resources.data.dimensions.outcomeAssignees.entities.assignee
    .attributes.isResponsible.RESOURCE.payload
const IS_ACCOUNTABLE_MODEL =
  ents.extra.quiver.resources.data.dimensions.outcomeAssignees.entities.assignee
    .attributes.isAccountable.RESOURCE.payload
const IS_CONSULTED_MODEL =
  ents.extra.quiver.resources.data.dimensions.outcomeAssignees.entities.assignee
    .attributes.isConsulted.RESOURCE.payload
const IS_INFORMED_MODEL =
  ents.extra.quiver.resources.data.dimensions.outcomeAssignees.entities.assignee
    .attributes.isInformed.RESOURCE.payload
export interface UnitOutcomeAssignment {
  readonly unitId: string
  readonly outcomeId: string
}
export namespace UnitOutcomeAssignment {
  export const isUnitOutcomeAssignment =
    TypeChecker.Factory.object<UnitOutcomeAssignment>({
      outcomeId: TypeChecker.isString,
      unitId: TypeChecker.isString,
    })

  /**
   * Represents assignment role types that can filter
   * {@link UnitOutcomeAssignment} entities.
   */
  export type Filter = (typeof Filter.ALL)[number]
  export namespace Filter {
    /** All available filter types for {@link UnitOutcomeAssignment} entities. */
    export const ALL = [
      IS_RESPONSIBLE_MODEL.name,
      IS_ACCOUNTABLE_MODEL.name,
      IS_CONSULTED_MODEL.name,
      IS_INFORMED_MODEL.name,
    ]
    /** Default filter types for {@link UnitOutcomeAssignment} entities. */
    export const DEFAULTS = [IS_RESPONSIBLE_MODEL.name]

    /** Mapping of filter names to their corresponding partial IDs. */
    const NAME_TO_PARTIAL_ID_LOOKUP: Record<Filter, PartialId> = {
      [IS_RESPONSIBLE_MODEL.name]: IS_RESPONSIBLE_MODEL.partialId,
      [IS_ACCOUNTABLE_MODEL.name]: IS_ACCOUNTABLE_MODEL.partialId,
      [IS_CONSULTED_MODEL.name]: IS_CONSULTED_MODEL.partialId,
      [IS_INFORMED_MODEL.name]: IS_INFORMED_MODEL.partialId,
    }

    /**
     * Converts an array of {@link Filter} types into a
     * {@link ents.core.dms.data.query.Query.filter} expression compatible with the DMS.
     */
    export function toQueryFilters(filters: readonly Filter[]) {
      switch (filters.length) {
        case 0:
          return undefined
        case 1:
          return {
            '=': [{ '@.': NAME_TO_PARTIAL_ID_LOOKUP[filters[0]] }, true],
          }
        default:
          return {
            or: filters.map(filter => ({
              '=': [{ '@.': NAME_TO_PARTIAL_ID_LOOKUP[filter] }, true],
            })),
          }
      }
    }
  }
}
